import React, { useState } from "react"
import styled from "styled-components"
import { navigate } from "gatsby"
import withApolloClient from "../withApolloClient"
import { 
  RoundedButton, 
  inBrowser, 
  decodeUserToken, 
  getDeviceId, 
  theme,
  trackCheckout_GTM } from "@omnichannel/ace-b2b-elements"
// import { inBrowser } from "../../utils/utils"
import { isEmpty } from "underscore"
// import decodeUserToken from "../../helpers/decodeUserToken"
import { preCheckoutMutationGQL, doCheckoutMutationGQL } from "../../components/gql/checkout"
import { getShoppingCartQueryGQL } from "../../components/gql/cart"
import { LOGIN_URL, BASE_URL, APP_ID } from "../../helpers/constants"
import { useMutation } from "@apollo/react-hooks"
// import { getDeviceId } from "@omnichannel/ace-b2b-elements"

import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

const ButtonText = styled.div`
  font-size: 1.4rem;
  color: ${props => (props.color ? props.color : "#3e3f42")};
  letter-spacing: 0.4px;
  text-align: center;
  white-space: nowrap;
  padding: 0 4rem;
  margin: 0 1rem;
  @media (max-width: 767px) {
    padding: 0 2rem;
  }
`

let deviceId = undefined
if (inBrowser) {
  getDeviceId().then(result => {
    deviceId = result
  })
}

const CartPopCheckout = props => {
  let userInfo = null
  const accessToken = inBrowser ? localStorage.getItem("access-token") : ""
  if (accessToken) {
    userInfo = (accessToken)
  }

  const headers = {
    deviceId: deviceId,
  }

  const notifyError = message =>
  toast.error(message, {
    pauseOnFocusLoss: false,
    autoClose: true,
  })

  const [preCheckout] = useMutation(preCheckoutMutationGQL, {
    context: { headers: headers },
    fetchPolicy: "no-cache",
    refetchQueries: [{ getShoppingCartQueryGQL }],
    onCompleted: result => {
      setDisableProceedToCheckoutBtn(false)
      if (result.preCheckout) {
        trackCheckout_GTM( props.cartItemsForGTM ,() => {});
        onProceedToCheckout(result.preCheckout)
      }
    },
    onError: result => { 
      setDisableProceedToCheckoutBtn(false)
    },
  })

  const [doCheckout] = useMutation(doCheckoutMutationGQL, {
    fetchPolicy: "no-cache",
    refetchQueries: [ { query: getShoppingCartQueryGQL }],
    onCompleted: result => {
      setDisableProceedToCheckoutBtn(false)
      console.log("DO CHECKOUT :::", result)
    },
    onError: result => {
      setDisableProceedToCheckoutBtn(false)
      if(result && result.graphQLErrors[0] && result.graphQLErrors[0].message)
        notifyError(`There was a problem with:  ${result.graphQLErrors[0].message}`)
    },
  })

  const [
    disableProceedToCheckoutBtn,
    setDisableProceedToCheckoutBtn,
  ] = useState(false)


  const onLogin = () => {
    window.location.href = `${LOGIN_URL}/?redirectUrl=${encodeURIComponent(
      BASE_URL
    )}/cart`
  }

  const onProceedToCheckout = preCheckoutId => {
    navigate(`/check/?id=${preCheckoutId}`)
  }

  return (
    <>
      {isEmpty(userInfo) ? (
        <RoundedButton
          width="100%"
          color={theme[APP_ID].yellow}
          borderColor={theme[APP_ID].yellow}
          onClick={() => onLogin()}
        >
          <ButtonText color={"#fff"}>Login to Order</ButtonText>
        </RoundedButton>
      ) : (
          <RoundedButton
            width="100%"
            color={theme[APP_ID].yellow}
            disabled={disableProceedToCheckoutBtn}
            onClick={() => {
              if (!disableProceedToCheckoutBtn) {
                setDisableProceedToCheckoutBtn(true)
                {/* preCheckout({
                  variables: {
                    cartItemIds: props.getItemsForCheckout,
                  },
                }); */}
 
                doCheckout({
                  variables: {
                    cartItemIds: props.getItemsForCheckout
                  }
                })
              }
            }}
          >
            <ButtonText color={"#fff"}>Send to Order</ButtonText>
          </RoundedButton>
        )}
    </>
  )
}

export default withApolloClient(CartPopCheckout, { client: "b2bClient" })
